import { Component, useState } from "react";
import config from "environment";
import "./WazToolbar.css";
import { AppWindow, Files, FileSearch, MessageSquare, Paintbrush, Pin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  KB_MENUS,
  TOOLS,
  selectEditingCollection,
  selectUIStates,
  selectUser,
  setUIStates,
} from "../../../redux/features/appData";
import { useDispatch } from "react-redux";
import { WazAvatarMenu } from "./WazAvatarMenu";
import { WazSlackMessages } from "../demo/WazSlackMessages";
import { useSlackNotifications } from "../demo/useSlackNotifications";
import { Toaster } from "react-hot-toast";

const enableWaz = config.enableWaz;

type WazToolbarProps = {
  viewingApp?: boolean;
  viewingKB?: boolean;
};

export const WazToolbar = ({
  viewingApp = false,
  viewingKB = false,
}: WazToolbarProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const uiStates = useSelector(selectUIStates);
  const selectedTool = uiStates.selectedTool || TOOLS.CHAT;
  const editingCollection = useSelector(selectEditingCollection);
  const currentCollectionId = editingCollection?.id;
  const storeUser = useSelector(selectUser);
  const [isExpanded, setIsExpanded] = useState<boolean>(viewingApp);

  const [avatarAnchorEl, setAvatarAnchorEl] = useState<null | HTMLElement>(
    null
  );

  // Slack notifications hook
  const { notification, hideNotification } = useSlackNotifications();

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAvatarAnchorEl(event.currentTarget);
  };

  const handleAvatarMenuClose = () => {
    setAvatarAnchorEl(null);
  };

  // make sure we set the mode
  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  // const [isKBExpanded, setIsKBExpanded] = useState<boolean>(viewingKB);

  // console.log("[WazToolbar] selectedTool: ", selectedTool);
  // console.log("[WazToolbar] currentCollectionId: ", currentCollectionId);
  // console.log("[WazToolbar] editingCollection: ", editingCollection);

  return (
    <>
      <div className="waz-toolbar">
        {/* <div 
                    className={selectedTool === TOOLS.HOME ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                    onClick={() => {
                        dispatch(setUIStates({...uiStates, selectedTool: TOOLS.HOME}));
                        navigate("/waz/home");
                    }}
                >
                    <Home size={16} />
                </div> */}

        <div
          key={TOOLS.CHAT}
          className={
            selectedTool === TOOLS.CHAT
              ? "waz-toolbar-tool-selected"
              : "waz-toolbar-tool"
          }
          onClick={() => {
            dispatch(setUIStates({ ...uiStates, selectedTool: TOOLS.CHAT }));
            navigate("/waz/chat/" + currentCollectionId);
          }}>
          {/* <MessageSquare size={16} color={selectedTool === TOOLS.CHAT ? "#FF543D" : "black"}/> */}
          <MessageSquare size={16} color={selectedTool === TOOLS.CHAT ? "black" : "black"}/>

        </div>

        {config.enableWaz && 
          <>
            <div
              key={TOOLS.HRIS}
              // className="waz-toolbar-login"
              className={
                selectedTool === TOOLS.HRIS
                  ? "waz-toolbar-tool-selected"
                  : "waz-toolbar-tool"
              }
              style={selectedTool === TOOLS.HRIS ? {backgroundColor: "red"} : {}}
              onClick={() => {
                if (selectedTool !== TOOLS.HRIS) {
                  dispatch(
                    setUIStates({
                      ...uiStates,
                      selectedTool: TOOLS.HRIS
                          
                    })
                  );
                  
                  setIsExpanded(true);
                  navigate("/app");
                
                }
              }}>
              <AppWindow size={16} color={selectedTool === TOOLS.HRIS ? "white" : "black"} />
            </div>
      
            <div 
              key={TOOLS.DESIGN}
                className={selectedTool === TOOLS.DESIGN ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, selectedTool: TOOLS.DESIGN}));
                    setIsExpanded(!isExpanded);
                    navigate("/waz/admin/design");

                }}
            >
                <Paintbrush size={16} />        
            </div>
          </>
        }

        {/* <div
          className={
            selectedTool === TOOLS.PIN
              ? "waz-toolbar-tool-selected"
              : "waz-toolbar-tool"
          }
          onClick={() => {
            dispatch(setUIStates({ ...uiStates, selectedTool: TOOLS.PIN }));
            navigate("/waz/pins");
          }}>
          <Pin size={16} />
        </div> */}

        <div
          key={TOOLS.KB}
          className={
            selectedTool === TOOLS.KB
              ? "waz-toolbar-tool-selected"
              : "waz-toolbar-tool"
          }
          style={selectedTool === TOOLS.KB ? {backgroundColor: "green"} : {}}

          onClick={() => {
            if (selectedTool !== TOOLS.KB) {
            //   dispatch(setUIStates({ ...uiStates, selectedTool: TOOLS.CHAT }));
            //   navigate("/waz/chat/" + currentCollectionId);
            // } else {
              dispatch(setUIStates({ 
                ...uiStates, 
                selectedTool: TOOLS.KB,
                kbSelectedMenu: KB_MENUS.ACTIVITY
              }));
              navigate("/waz/kb");
            }
          }}>
          <FileSearch size={16} color={selectedTool === TOOLS.KB ? "white" : "black"} />
        </div>


        <div 
            className={selectedTool === TOOLS.DOCUMENTS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
            style={selectedTool === TOOLS.DOCUMENTS ? {backgroundColor: "blue"} : {}}

            onClick={() => {
                dispatch(setUIStates({...uiStates, selectedTool: TOOLS.DOCUMENTS}));
                // setIsExpanded(!isExpanded)
                navigate("/waz/documents");
            }}
          >
              <Files size={16} color={selectedTool === TOOLS.DOCUMENTS ? "white" : "black"}/>
          </div>

        {/* <div 
              className={selectedTool === TOOLS.TICKET ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
              onClick={() => dispatch(setUIStates({...uiStates, selectedTool: TOOLS.TICKET}))}
          >
              <Ticket size={16} />
          </div>

          <div 
              className={selectedTool === TOOLS.NOTIFICATIONS ? "waz-toolbar-tool-selected" : "waz-toolbar-tool"}
              onClick={() => dispatch(setUIStates({...uiStates, selectedTool: TOOLS.NOTIFICATIONS}))}
          >
              <Bell size={16} />
          </div> */}

       


        <div className="waz-toolbar-avatar" onClick={handleAvatarClick}>
          <img src={storeUser?.avatarURL || undefined} alt="avatar" />
        </div>

        <WazAvatarMenu
          anchorEl={avatarAnchorEl}
          onClose={handleAvatarMenuClose}
        />
      </div>

      {/* {isExpanded && selectedTool === TOOLS.APP &&
                <AppSidebar />
            } */}

      {/* Slack Notifications */}
      {/* {notification.isVisible && (
        <WazSlackMessages
          demoIndex={notification.demoIndex}
          onDismiss={hideNotification}
        />
      )} */}

      <Toaster />

    </>
  );
};
